/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import { CHECK_APPLE_PAY_ENABLED } from './ApplePay-ActionTypes';

export const checkApplePayEnabled = () => ({
    type: CHECK_APPLE_PAY_ENABLED,
});

export default {};
